export const BG_PRIMARY = '#6EA2CF';
export const BG_SECONDARY = '#C4AFDD';
export const BG_ALTERNATIVE = '#B18F68';
// color text
export const TEXT_PRIMARY = '#FFFFFF';
export const TEXT_SECONDARY = '#F8F0DE';
export const TEXT_ALTERNATIVE = '#B47461';
// music & navigation
export const NAVIGATION_COLOR = '#ba9bdf';
export const DRAWER_COLOR = '#ba9bdf';
export const BORDER_COLOR = '#E3D5CC';
export const FOOTER_COLOR = '#7e6c696e';

// DEFAULT BUTTON PROPS
export const BUTTON_GRADIENT = `linear-gradient(to left, #5babd0, #e2e2e278 140%)`;
export const BUTTON_PROPS = {
  _active: { borderColor: 'transparent' },
  _hover: { borderColor: 'transparent' },
  _focus: { borderColor: 'transparent' },
};
